import ApplicationController from 'javascript/controllers/application_controller';
import { trackGa4Event } from 'javascript/utils/utils';
import { Rails } from 'javascript/utils/rails_polyfills';

export default class extends ApplicationController {
  static targets = ['errorContainer', 'error', 'input'];

  beforeSubmit() {
    this.element.classList.add('contents-loading');
  }

  submitSuccess({ detail: [, , xhr] }) {
    this.element.classList.remove('contents-loading');
    const ga4UserData = xhr.response;
    this.trackRegistration(ga4UserData);
    this.onSuccess(xhr.getResponseHeader('Location'));
  }

  trackRegistration(userJson) {
    try {
      const userProvidedData = JSON.parse(userJson);

      trackGa4Event('registration', {
        user_provided_data: {
          ...userProvidedData,
        },
      });
    } catch (exception) {
      console.error(exception);
    }
  }

  submitError({ detail: [response, , xhr] }) {
    this.element.classList.remove('contents-loading');

    let errors;
    switch (xhr.status) {
      case 422:
        errors = response?.errors?.user ?? (response?.errors ? null : response);
        break;
    }

    if (!errors || Object.entries(errors).length === 0) {
      return;
    }

    this.errorContainerTarget.classList.remove('util-hidden');
    this.errorTarget.innerHTML = Object.keys(errors).reduce(
      (string, key) => `
        ${string}
        <span class="form-error__line">${errors[key][0]}</span>
      `,
      '',
    );

    [].forEach.call(this.inputTargets, (input) => {
      if (errors[input.dataset.field]) {
        input.classList.add('has-error');
      } else {
        input.classList.remove('has-error');
      }
    });

    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth',
    });
  }

  onSuccess = (url) => {
    Rails.fire(this.element, 'howler:user-setup.success', [url]);
  };
}
